<template>
  <div class="listQueryBox">
    <el-card class="mb5">
      <el-form class="selectClass">
        <el-row>
          <el-col :span="7" style="width: auto">
            <!-- 省份： -->
            <el-form-item :label="$t('collectionCenter.province')">
              <el-select
                v-model="queryForm.params.twoCode"
                :placeholder="$t('collectionCenter.pleaseChoose')"
                clearable
                filterable
              >
                <el-option
                  v-for="(item, index) in twoCodeList"
                  :key="index"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7" style="width: auto">
            <!-- 起始邮编： -->
            <el-form-item :label="$t('collectionCenter.startZipC')">
              <el-input
                v-model.trim="queryForm.params.startZipCode"
                :placeholder="$t('collectionCenter.pleaseInput')"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <!-- 城市名称： -->
            <el-form-item :label="$t('collectionCenter.cityName')">
              <el-input
                v-model.trim="queryForm.params.extra"
                :placeholder="$t('collectionCenter.pleaseInput')"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row>
        <el-col :span="12">
          <el-button
            v-permit:remove="'btn:collection-center:basicDate:zipZone:search'"
            icon="el-icon-search"
            size="mini"
            type="primary"
            @click="searchClick"
          >{{ $t('collectionCenter.search') }}
          </el-button>
          <!-- 查询 -->
          <el-button
            v-permit:remove="'btn:collection-center:basicDate:zipZone:reset'"
            icon="el-icon-refresh"
            size="mini"
            @click="resetClick"
          >{{ $t('collectionCenter.reset') }}
          </el-button>
          <!-- 重置 -->
          <el-button
            v-permit:remove="'btn:collection-center:basicDate:zipZone:add'"
            icon="el-icon-plus"
            size="mini"
            type="primary"
            @click="addClick"
          >{{ $t('collectionCenter.add') }} </el-button><!-- 新增 -->
          <el-button
            v-permit:remove="'btn:collection-center:basicDate:zipZone:export'"
            :class="idList.length <= 0 && isClick ? 'onlyClickOnce10' : ''"
            icon="el-icon-upload2"
            size="mini"
            @click="download"
          >{{ $t('collectionCenter.export') }}
          </el-button>
          <!-- 导出 -->
        </el-col>
      </el-row>
    </el-card>
    <el-card>
      <el-table
        ref="tableRef"
        :data="tableDate"
        :max-height="600"
        border
        @select="batchSelect"
        @select-all="batchSelectAll"
      >
        <el-table-column type="selection" width="55" />
        <!-- 序号 -->
        <el-table-column
          :label="$t('collectionCenter.ind')" align="center" type="index"
          width="60"
        >
          <template slot-scope="scope">
            <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('collectionCenter.provinceee')"
          align="center"
          prop="twoCode"
        /><!-- 省份 -->
        <el-table-column
          :label="$t('collectionCenter.city')"
          align="center"
          prop="city"
        /><!-- 城市名称 -->
        <el-table-column
          :label="$t('collectionCenter.startZipCode')"
          align="center"
          prop="startZipCode"
        /><!-- 起始邮编 -->
        <el-table-column
          :label="$t('collectionCenter.endZipCode')"
          align="center"
          prop="endZipCode"
        /><!-- 结束邮编 -->
        <el-table-column
          :label="$t('collectionCenter.group')"
          align="center"
          prop="divideGroups"
        /><!-- 组别 -->
        <el-table-column
          :label="$t('collectionCenter.region')"
          align="center"
          prop="macroRegion"
        /><!-- 大区 -->
        <el-table-column
          :label="$t('collectionCenter.area')"
          align="center"
          prop="microRegion"
        /><!-- 区域 -->
        <el-table-column
          v-if="edit || del"
          :label="$t('collectionCenter.operation')"
          align="center"
          fixed="right"
          width="160"
        ><!-- 操作 -->
          <template slot-scope="scope">
            <el-button
              v-if="edit"
              plain
              size="mini"
              type="primary"
              @click="editCellClick(scope.row)"
            >{{ $t('collectionCenter.modify') }}
            </el-button>
            <el-popconfirm
              :title="$t('collectionCenter.deleteSure')"
              @confirm="delCellClick(scope.row, scope.$index)"
            >
              <el-button
                v-if="del" slot="reference" plain
                size="mini" type="danger"
              >{{ $t('collectionCenter.Delete') }}
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <div class="right">
        <el-pagination
          :current-page.sync="queryForm.pageNumber"
          :page-size.sync="queryForm.pageSize"
          :page-sizes="[10, 20, 50, 100, 500, 1000]"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          style="margin: 10px 0"
          @current-change="getListPage"
          @size-change="getPageSize"
        />
      </div>
    </el-card>

    <div v-if="drawerIsOpen">
      <el-drawer
        :direction="direction"
        :title="drawerTitle"
        :visible.sync="drawerIsOpen"
        size="40%"
        @close="closeDrawer"
      >
        <div class="drawerClass">
          <el-form ref="drawerFormRef" :model="drawerForm" :rules="rules">
            <el-row justify="space-between" style="flex-wrap: wrap" type="flex">
              <el-col :span="11">
                <!-- 省份： -->
                <el-form-item :label="$t('collectionCenter.province')" prop="twoCode">
                  <el-input
                    v-model="drawerForm.twoCode"
                    :placeholder="$t('collectionCenter.pleaseInput')"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <!-- 省份扩展名称： -->
                <el-form-item
                  :label="$t('collectionCenter.provinceExtensionName')"
                  prop="twoCodeExtra"
                >
                  <el-input
                    v-model="drawerForm.twoCodeExtra"
                    :placeholder="$t('collectionCenter.pleaseInput')"
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row justify="space-between" style="flex-wrap: wrap" type="flex">
              <el-col :span="11">
                <!-- 城市名称： -->
                <el-form-item :label="$t('collectionCenter.city') + '：'" prop="city">
                  <el-input
                    v-model="drawerForm.city"
                    :placeholder="$t('collectionCenter.pleaseInput')"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <!-- 城市扩展名称： -->
                <el-form-item :label="$t('collectionCenter.cityExtraName')" prop="extra">
                  <el-input
                    v-model="drawerForm.extra"
                    :placeholder="$t('collectionCenter.pleaseInput')"
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row justify="space-between" style="flex-wrap: wrap" type="flex">
              <el-col :span="11">
                <!-- 起始邮编： -->
                <el-form-item :label="$t('collectionCenter.startZipC')" prop="startZipCode">
                  <el-input
                    v-model.trim="drawerForm.startZipCode"
                    :placeholder="$t('collectionCenter.pleaseInput')"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <!-- 结束邮编： -->
                <el-form-item :label="$t('collectionCenter.endZipC')" prop="endZipCode">
                  <el-input
                    v-model.trim="drawerForm.endZipCode"
                    :placeholder="$t('collectionCenter.pleaseInput')"
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row justify="space-between" style="flex-wrap: wrap" type="flex">
              <el-col :span="11">
                <!-- 组别： -->
                <el-form-item :label="$t('collectionCenter.group') + '：'" prop="divideGroups">
                  <el-input
                    v-model.trim="drawerForm.divideGroups"
                    :placeholder="$t('collectionCenter.pleaseInput')"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <!-- 大区： -->
                <el-form-item :label="$t('collectionCenter.region') + '：'" prop="macroRegion">
                  <el-input
                    v-model.trim="drawerForm.macroRegion"
                    :placeholder="$t('collectionCenter.pleaseInput')"
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row justify="start" type="flex">
              <el-col :span="11">
                <!-- 区域： -->
                <el-form-item :label="$t('collectionCenter.area') + '：'" prop="microRegion">
                  <el-input
                    v-model.trim="drawerForm.microRegion"
                    :placeholder="$t('collectionCenter.pleaseInput')"
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="submitClickBtn">
            <el-button @click="submitClick">{{ $t('collectionCenter.Save') }}</el-button><!-- 保存 -->
          </div>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import {
  provinceQueryAll,
  zipCodeDivision,
  zipCodeDivisionAdd,
  zipCodeDivisionDel,
  zipCodeDivisionEdit,
  zipCodeDivisionExport
} from '@/api/lanshou';
import { goRWExportList } from '@/utils/goExportList.js';

export default {
  name: 'ZipZone',
  data() {
    return {
      isClick: false,
      edit: this.$store.getters.button_permissions.includes(
        'btn:collection-center:basicDate:zipZone:edit'
      ),
      del: this.$store.getters.button_permissions.includes(
        'btn:collection-center:basicDate:zipZone:del'
      ),
      drawerIsOpen: false,
      drawerTitle: '',
      direction: 'ltr',
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          twoCode: '',
          startZipCode: '',
          extra: ''
        }
      },
      twoCodeList: [],
      total: 0,
      tableDate: [],
      idList: [], // 导出id
      drawerForm: {
        twoCode: '',
        city: '', // 城市名称
        extra: '', // 城市扩展名称
        twoCodeExtra: '', // 省份扩展名称
        startZipCode: '',
        endZipCode: '',
        divideGroups: '',
        macroRegion: '',
        microRegion: ''
      },
      rules: {
        twoCode: [
          {
            required: true,
            message: this.$t('collectionCenter.notNull'),
            trigger: ['blur', 'change']
          },
          {
            validator: async(rule, value, callback) => {
              const twoCodeRep = /^[A-Z]{1,2}$/g;
              if (!twoCodeRep.test(value)) {
                return callback(new Error(this.$t('collectionCenter.pleaseInputStateTwoCode'))); // '请填写对应州二字码(大写)'
              } else {
                callback();
              }
            }
          }
        ],
        startZipCode: [
          {
            required: true,
            message: this.$t('collectionCenter.notNull'),
            trigger: ['blur', 'change']
          },
          {
            validator: async(rule, value, callback) => {
              const reg = /^[0-9]{8}$/g;
              if (!reg.test(value)) {
                return callback(new Error(this.$t('collectionCenter.input8Sum'))); // '请输入8位数字'
              } else if (
                this.drawerForm.endZipCode &&
                this.drawerForm.startZipCode >= this.drawerForm.endZipCode &&
                this.drawerForm.startZipCode.length === 8 &&
                this.drawerForm.endZipCode.length === 8
              ) {
                return callback(new Error(this.$t('collectionCenter.startZipcodeLessEndZipcode'))); // '开始邮编不能大于或等于结束邮编'
              } else {
                if (this.drawerForm.endZipCode && this.drawerForm.endZipCode.length === 8) {
                  this.$refs.drawerFormRef.clearValidate('endZipCode');
                }
                callback();
              }
            }
          }
        ],
        endZipCode: [
          {
            required: true,
            message: this.$t('collectionCenter.notNull'),
            trigger: ['blur', 'change']
          },
          {
            validator: async(rule, value, callback) => {
              const reg = /^[0-9]{8}$/g;
              if (!reg.test(value)) {
                return callback(new Error(this.$t('collectionCenter.input8Sum'))); // '请输入8位数字'
              } else if (
                this.drawerForm.startZipCode &&
                this.drawerForm.startZipCode >= this.drawerForm.endZipCode &&
                this.drawerForm.startZipCode.length === 8 &&
                this.drawerForm.endZipCode.length === 8
              ) {
                return callback(new Error(this.$t('collectionCenter.startZipcodeLessEndZipcode'))); // '开始邮编不能大于或等于结束邮编'
              } else {
                if (this.drawerForm.startZipCode && this.drawerForm.startZipCode.length === 8) {
                  this.$refs.drawerFormRef.clearValidate('startZipCode');
                }
                callback();
              }
            }
          }
        ],
        city: [
          {
            required: true,
            message: this.$t('collectionCenter.notNull'),
            trigger: ['blur', 'change']
          }
        ],
        extra: [
          {
            required: true,
            message: this.$t('collectionCenter.notNull'),
            trigger: ['blur', 'change']
          }
        ],
        twoCodeExtra: [
          {
            required: true,
            message: this.$t('collectionCenter.notNull'),
            trigger: ['blur', 'change']
          }
        ],
        divideGroups: [
          {
            required: true,
            message: this.$t('collectionCenter.notNull'),
            trigger: ['blur', 'change']
          }
        ],
        macroRegion: [
          {
            required: true,
            message: this.$t('collectionCenter.notNull'),
            trigger: ['blur', 'change']
          }
        ],
        microRegion: [
          {
            required: true,
            message: this.$t('collectionCenter.notNull'),
            trigger: ['blur', 'change']
          }
        ]
      }
    };
  },
  created() {
    this.defaultCondition();
    this.searchClick();
    this.getSheng();
    this.isClick = false;
  },
  methods: {
    getSheng() {
      const data = {};
      provinceQueryAll(data)
        .then((res) => {
          if (res.status === 'OK') {
            this.twoCodeList = res.data;
            // res.data.forEach((item) => {
            //   this.twoCodeList.push({
            //     twoCode: item.twoCode
            //   });
            // });
          }
        })
        .catch((err) => {
          console.log(err);
          this.twoCodeList = [];
        });
    },
    getListPage() {
      // 表格
      this.$nextTick(() => {
        this.idList = [];
        this.$refs.tableRef.clearSelection();
      });
      const queryForm = JSON.parse(localStorage.getItem('zzQueryForm')) || this.queryForm;
      queryForm.pageNumber = this.queryForm.pageNumber;
      queryForm.pageSize = this.queryForm.pageSize;
      zipCodeDivision(queryForm).then((res) => {
        if (res.status === 'OK') {
          this.tableDate = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    defaultCondition() {
      // 默认查询条件
      this.queryForm.params = {
        twoCode: '',
        startZipCode: '',
        extra: ''
      };
    },
    getPageSize() {
      this.queryForm.pageNumber = 1;
      const query = JSON.parse(localStorage.getItem('zzQueryForm')) || this.queryForm;
      const queryForm = {
        pageNumber: 1,
        pageSize: this.queryForm.pageSize,
        params: query.params
      };
      zipCodeDivision(queryForm).then((res) => {
        if (res.status === 'OK') {
          this.tableDate = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    searchClick() {
      if (this.queryForm.params.startZipCode.length > 8) {
        this.$message.warning(this.$t('collectionCenter.input8ZipCode')); // 请输入8位邮编
        return;
      }
      this.queryForm.pageNumber = 1;
      localStorage.setItem('zzQueryForm', JSON.stringify(this.queryForm));
      // 查询
      this.getListPage();
    },
    resetClick() {
      // 重置
      this.queryForm.params.twoCode = '';
      this.queryForm.params.startZipCode = '';
      this.queryForm.params.extra = '';
    },
    addClick() {
      this.drawerIsOpen = true;
      this.drawerTitle = this.$t('collectionCenter.add');
    },
    editCellClick(row) {
      this.drawerIsOpen = true;
      this.drawerTitle = this.$t('collectionCenter.modify');
      this.drawerForm = {
        twoCode: row.twoCode,
        city: row.city, // 城市名称
        extra: row.extra, // 城市扩展名称
        twoCodeExtra: row.twoCodeExtra, // 省份扩展名称
        startZipCode: row.startZipCode,
        endZipCode: row.endZipCode,
        divideGroups: row.divideGroups,
        macroRegion: row.macroRegion,
        microRegion: row.microRegion
      };
      this.drawerForm.id = row.id;
    },
    submitClick() {
      this.$refs['drawerFormRef'].validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.drawerForm.startZipCode.length !== 8 || this.drawerForm.endZipCode.length !== 8) {
          return;
        }
        if (this.drawerTitle === this.$t('collectionCenter.add')) {
          zipCodeDivisionAdd(this.drawerForm).then((res) => {
            if (res.status === 'OK') {
              this.drawerIsOpen = false;
              this.$message({
                message: this.$t('collectionCenter.SaveSuccessfully'), // '保存成功'
                type: 'success'
              });
              this.closeDrawer();
              this.searchClick();
              this.getSheng();
            }
          });
        }
        if (this.drawerTitle === this.$t('collectionCenter.modify')) {
          zipCodeDivisionEdit(this.drawerForm).then((res) => {
            if (res.status === 'OK') {
              this.drawerIsOpen = false;
              this.$message({
                message: this.$t('collectionCenter.ModificationSuccessful'), // '修改成功'
                type: 'success'
              });
              this.closeDrawer();
              this.searchClick();
              this.getSheng();
            }
          });
        }
      });
      // this.searchClick(); // 提交成功后调用
    },
    closeDrawer() {
      // 关闭弹窗
      this.drawerForm = {
        twoCode: '',
        city: '', // 城市名称
        extra: '', // 城市扩展名称
        twoCodeExtra: '', // 省份扩展名称
        startZipCode: '',
        endZipCode: '',
        divideGroups: '',
        macroRegion: '',
        microRegion: ''
      };
      this.$refs['drawerFormRef'].clearValidate();
    },
    delCellClick(row, index) {
      const data = {
        id: row.id
      };
      zipCodeDivisionDel(data).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: this.$t('collectionCenter.DeleteSucceeded'), // '删除成功'
            type: 'success'
          });
          this.searchClick();
          this.getSheng();
        }
      });
    },
    batchSelect(selection, row) {
      const collectListIdList = [];
      selection.forEach((list) => {
        collectListIdList.push(list.id);
      });
      this.idList = collectListIdList;
    },
    batchSelectAll(selection) {
      const collectListIdListAll = [];
      selection.forEach((list) => {
        collectListIdListAll.push(list.id);
      });
      this.idList = collectListIdListAll;
    },
    download() {
      // 导出
      this.isClick = true;
      if (this.idList.length <= 0) {
        // 请勾选要导出的数据
        this.$message.warning(this.$t('collectionCenter.PleaseTickTheDataExport'));
      } else {
        const queryForm = {
          idList: this.idList
        };
        zipCodeDivisionExport(queryForm)
          .then((res) => {
            if (res.status === 'OK') {
              this.isClick = false;
              this.idList = [];
              this.$refs.tableRef.clearSelection();
              goRWExportList(this);
            }
          })
          .catch((err) => {
            console.log(err);
            this.isClick = false;
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// 防止按钮重复点击
@keyframes throttle {
  from {
    filter: opacity(40%);
    pointer-events: none;
  }
  to {
    pointer-events: all;
  }
}

.onlyClickOnce2 {
  animation: throttle 2s step-end forwards;
}

.onlyClickOnce2:active {
  filter: opacity(40%);
  animation: none;
}

.onlyClickOnce10 {
  animation: throttle 10s step-end forwards;
}

.onlyClickOnce10:active {
  filter: opacity(40%);
  animation: none;
}

.selectClass ::v-deep .el-form-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.selectClass ::v-deep .el-form-item__label {
  padding: 0;
  line-height: 16px;
  white-space: nowrap;
  margin-left: 20px;
}

.selectClass ::v-deep .el-form-item__content {
  margin-left: 0 !important;
  width: 100%;
}

.submitClickBtn {
  text-align: right;
  margin-top: 30px;
}

.selectClass ::v-deep .el-select {
  width: 100%;
}

.listQueryBox,
.drawerClass {
  padding: 20px;
  box-sizing: border-box;
}

.right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
